(() => {
  const S = window.Syve || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const store = {
    get(key, fallback) {
      try { const v = localStorage.getItem(key); return v === null ? fallback : JSON.parse(v); } catch (e) { return fallback; }
    },
    set(key, value) {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ }
    }
  };

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = S.moneyFormat || '{{amount}}';
    const value = Number(cents) / 100;
    const withSep = (n, d, t, dec) => {
      const parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(dec);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withSep(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withSep(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withSep(value, 2, "'", '.');
        default: return withSep(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(html) {
    const el = $('#SyveToast');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  /* ---------- Cart ---------- */
  function setCartCount(n) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n > 0 ? `(${n})` : ''; });
  }
  async function addToCart(variantId, button) {
    if (!variantId) return;
    const label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = '…'; }
    try {
      const res = await fetch(S.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      const hasBag = await refreshBag();
      if (hasBag && S.openOnAdd) openBag();
      else toast(`${S.strings.added}<a href="${S.routes.cart}">${S.strings.viewBag}</a>`);
    } catch (err) {
      toast(String(err.message || err));
    } finally {
      if (button) { button.disabled = false; button.textContent = label; }
    }
  }

  /* ---------- Bag (full screen cart) ---------- */
  const bagEl = () => $('[data-bag]');
  async function refreshBag() {
    try {
      const cart = await fetch(S.routes.cartJs).then((r) => r.json());
      setCartCount(cart.item_count);
    } catch (e) { /* ignore */ }
    const bag = bagEl();
    if (!bag) return false;
    try {
      const root = (S.routes.root || '/');
      const data = await fetch(`${root}${root.includes('?') ? '&' : '?'}sections=bag`).then((r) => r.json());
      const doc = new DOMParser().parseFromString(data.bag || '', 'text/html');
      const fresh = doc.querySelector('[data-bag-inner]');
      const cur = $('[data-bag-inner]', bag);
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      loadAutoUpsell();
      return true;
    } catch (e) { return false; }
  }
  function openBag() {
    const bag = bagEl();
    if (!bag) { window.location.href = S.routes.cart; return; }
    bag.hidden = false;
    document.body.classList.add('bag-open');
    loadAutoUpsell();
    const c = $('[data-bag-close]', bag);
    if (c) c.focus();
  }
  function closeBag() {
    const bag = bagEl();
    if (!bag || bag.hidden) return;
    bag.hidden = true;
    document.body.classList.remove('bag-open');
  }
  async function changeLine(line, quantity, btn) {
    const item = btn && btn.closest('.bag__item');
    if (item) item.style.opacity = '.4';
    try {
      const res = await fetch(S.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
      });
      const data = await res.json();
      if (!res.ok) toast(data.description || data.message || 'Error');
    } catch (e) { /* ignore */ }
    await refreshBag();
  }
  async function loadAutoUpsell() {
    const list = $('[data-upsell-auto]');
    if (!list || list.dataset.loaded === list.dataset.productId) return;
    list.dataset.loaded = list.dataset.productId;
    try {
      const url = `${S.routes.recs}?product_id=${list.dataset.productId}&limit=${Number(list.dataset.limit) + 4}&intent=complementary`;
      let data = await fetch(url).then((r) => r.json());
      if (!data.products || !data.products.length) {
        data = await fetch(`${S.routes.recs}?product_id=${list.dataset.productId}&limit=${Number(list.dataset.limit) + 4}`).then((r) => r.json());
      }
      const exclude = list.dataset.exclude || '';
      const items = (data.products || []).filter((p) => p.available && !exclude.includes(`,${p.id},`)).slice(0, Number(list.dataset.limit) || 4);
      if (!items.length) { list.closest('.upsell').hidden = true; return; }
      list.innerHTML = items.map((p) => {
        const v = p.variants.find((x) => x.available) || p.variants[0];
        const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=300` : '';
        const single = p.variants.length === 1;
        const select = single
          ? `<input type="hidden" value="${v.id}" data-upsell-variant>`
          : `<select data-upsell-variant>${p.variants.map((x) => `<option value="${x.id}"${x.available ? '' : ' disabled'}${x.id === v.id ? ' selected' : ''}>${x.title}</option>`).join('')}</select>`;
        return `<li class="upsell__card"><a class="upsell__img" href="${p.url}">${img ? `<img src="${img}" alt="" loading="lazy">` : ''}</a><a class="upsell__name" href="${p.url}">${p.title}</a><span class="muted">${formatMoney(v.price)}</span><div class="upsell__add">${select}<button type="button" class="upsell__btn" data-upsell-add>+ ${S.strings.add}</button></div></li>`;
      }).join('');
    } catch (e) { list.closest('.upsell').hidden = true; }
  }
  let noteTimer;
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-bag-note]')) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      fetch(S.routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
    }, 500);
  });
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-bag-open]');
    if (open && bagEl()) { e.preventDefault(); openBag(); return; }
    if (e.target.closest('[data-bag-close]')) { closeBag(); return; }
    const bag = bagEl();
    if (bag && e.target === bag) { closeBag(); return; }
    const q = e.target.closest('[data-qty]');
    if (q) { const line = q.closest('[data-line]'); if (line) changeLine(line.dataset.line, q.dataset.qty, q); return; }
    const up = e.target.closest('[data-upsell-add]');
    if (up) {
      const card = up.closest('.upsell__card');
      const v = $('[data-upsell-variant]', card);
      if (v) addToCart(v.value, up);
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeBag(); });

  /* ---------- Popup ---------- */
  function initPopup() {
    const pop = $('[data-popup]');
    if (!pop) return;
    const KEY = 'syve:popup';
    const days = Number(pop.dataset.days) || 7;
    const show = () => { pop.hidden = false; document.body.classList.add('popup-open'); };
    const hide = () => {
      pop.hidden = true;
      document.body.classList.remove('popup-open');
      store.set(KEY, Date.now());
    };
    pop.addEventListener('click', (e) => {
      if (e.target === pop || e.target.closest('[data-popup-close]')) hide();
      const code = e.target.closest('[data-copy]');
      if (code && navigator.clipboard) {
        navigator.clipboard.writeText(code.dataset.copy).then(() => toast(S.strings.copied)).catch(() => {});
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) hide(); });
    if ($('[data-popup-success]', pop)) {
      show();
      store.set(KEY, Date.now() + 3650 * 864e5);
      return;
    }
    if (pop.dataset.test === 'true') { show(); return; }
    const last = Number(store.get(KEY, 0));
    if (last && Date.now() - last < days * 864e5) return;
    setTimeout(show, (Number(pop.dataset.delay) || 0) * 1000);
  }

  /* ---------- Wishlist ---------- */
  const WKEY = 'syve:wishlist';
  const wishlist = {
    all() { return store.get(WKEY, []); },
    has(h) { return this.all().includes(h); },
    toggle(h) {
      const list = this.all();
      const i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.unshift(h);
      store.set(WKEY, list);
      syncWishUI();
      return i === -1;
    }
  };
  function syncWishUI() {
    const list = wishlist.all();
    $$('[data-wishlist-count]').forEach((el) => { el.textContent = list.length ? `(${list.length})` : ''; });
    $$('[data-wish-toggle]').forEach((btn) => {
      const on = list.includes(btn.dataset.wishToggle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (btn.hasAttribute('data-wish-label')) btn.textContent = on ? S.strings.wishlistRemove : S.strings.wishlistAdd;
      else btn.innerHTML = on ? '&#9829;' : '&#9825;';
    });
    document.dispatchEvent(new CustomEvent('syve:wishlist'));
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-wish-toggle]');
    if (t) { e.preventDefault(); wishlist.toggle(t.dataset.wishToggle); }
  });

  async function renderWishlist() {
    const listEl = $('[data-wishlist-list]');
    if (!listEl) return;
    const handles = wishlist.all();
    if (!handles.length) { listEl.innerHTML = `<li style="display:block;border:0">${S.strings.wishlistEmpty}</li>`; return; }
    listEl.innerHTML = '';
    const root = (S.routes.root || '/').replace(/\/$/, '');
    const products = await Promise.all(handles.map((h) =>
      fetch(`${root}/products/${encodeURIComponent(h)}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)
    ));
    products.forEach((p, i) => {
      if (!p) return;
      const li = document.createElement('li');
      const src = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=200` : '';
      const img = src ? `<img src="${src}" alt="">` : '<span></span>';
      li.innerHTML = `<a href="${p.url}">${img}</a><a href="${p.url}">${p.title}<span class="muted">${formatMoney(p.price)}</span></a><button type="button" class="link-btn" data-wish-remove="${handles[i]}">${S.strings.remove}</button>`;
      listEl.appendChild(li);
    });
  }
  function openWishlist() {
    const d = $('[data-wishlist-drawer]');
    if (!d) return;
    d.hidden = false;
    document.body.style.overflow = 'hidden';
    renderWishlist();
    const close = $('.drawer__head [data-wishlist-close]', d);
    if (close) close.focus();
  }
  function closeWishlist() {
    const d = $('[data-wishlist-drawer]');
    if (!d) return;
    d.hidden = true;
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-wishlist-open]')) openWishlist();
    if (e.target.closest('[data-wishlist-close]')) closeWishlist();
    const rm = e.target.closest('[data-wish-remove]');
    if (rm) { wishlist.toggle(rm.dataset.wishRemove); renderWishlist(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeWishlist(); });

  /* ---------- Header ---------- */
  function initHeader() {
    const header = $('[data-header]');
    if (header) {
      const setH = () => document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
      setH();
      window.addEventListener('resize', setH);
    }
    const btn = $('[data-nav-toggle]');
    const menu = $('[data-menu]');
    if (btn && menu && !btn.dataset.bound) {
      btn.dataset.bound = '1';
      const setOpen = (open) => {
        menu.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('menu-open', open);
      };
      btn.addEventListener('click', () => setOpen(menu.hidden));
      menu.addEventListener('click', (e) => {
        if (e.target === menu || e.target.closest('a, [data-wishlist-open]')) setOpen(false);
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) { setOpen(false); btn.focus(); } });
    }
  }

  /* ---------- Showcase ---------- */
  function initShowcase(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const dataEl = $('[data-products]', root);
    const stage = $('[data-stage]', root);
    let api = null;

    // View toggle (customer choice remembered)
    const viewBtns = $$('[data-view-btn]', root);
    const setView = (v, remember) => {
      root.dataset.view = v;
      viewBtns.forEach((b) => b.setAttribute('aria-pressed', b.dataset.viewBtn === v ? 'true' : 'false'));
      if (remember) store.set('syve:view', v);
      if (v === 'showcase' && api) api.layout();
    };
    if (viewBtns.length) {
      const saved = store.get('syve:view', null);
      if (saved === 'grid' || saved === 'showcase') setView(saved, false);
      viewBtns.forEach((b) => b.addEventListener('click', () => setView(b.dataset.viewBtn, true)));
    }

    if (!dataEl || !stage) return;
    let products = [];
    try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const items = $$('.stage__item', stage);
    if (!items.length) return;

    const activePct = (Number(root.dataset.activeSize) || 76) / 100;
    const sidePct = (Number(root.dataset.sideSize) || 26) / 100;
    const autoplay = Number(root.dataset.autoplay) || 0;

    const info = {
      title: $('[data-info-title]', stage),
      desc: $('[data-info-desc]', stage),
      link: $('[data-info-link]', stage)
    };
    const buy = {
      form: $('[data-buy]', stage),
      variant: $('[data-buy-variant]', stage),
      sizes: $('[data-buy-sizes]', stage),
      price: $('[data-buy-price]', stage),
      submit: $('[data-buy-submit]', stage),
      wish: $('[data-buy-wish]', stage)
    };
    const nav = $('[data-nav]', stage);
    const counter = $('[data-counter]', stage);
    let index = 0;
    let stepPx = 120; // distance between neighbours, used for drag

    const ratioOf = (el) => {
      const img = $('img', el);
      if (!img) return 0.5;
      const w = img.naturalWidth || Number(img.getAttribute('width')) || 1;
      const h = img.naturalHeight || Number(img.getAttribute('height')) || 2;
      return w / h;
    };

    function layout() {
      const W = stage.clientWidth;
      const H = stage.clientHeight;
      if (!W || !H) return;
      const mobile = W < 750;
      const navSpace = 44;
      const reserved = mobile && buy.form ? buy.form.offsetHeight + 28 : 0;
      const usableH = H - navSpace - reserved;
      const activeH = Math.min(usableH * (mobile ? 0.92 : 1), H * activePct);
      const sideH = H * sidePct * (mobile ? 0.8 : 1);
      const gap = mobile ? 14 : Math.max(24, W * 0.035);
      const n = items.length;
      const centerY = (usableH) / 2 + 8;
      const activeW = Math.min(activeH * ratioOf(items[index]), W * (mobile ? 0.82 : 0.44));
      stepPx = Math.max(60, sideH * 0.6 + gap);

      items.forEach((el, i) => {
        let d = i - index;
        if (n > 2) {
          if (d > n / 2) d -= n;
          if (d < -n / 2) d += n;
        }
        const ad = Math.abs(d);
        let x = 0;
        let h = activeH;
        if (ad > 0) {
          h = sideH;
          let dist = activeW / 2 + gap;
          for (let k = 1; k <= ad; k += 1) {
            const idx = (index + Math.sign(d) * k + n * 10) % n;
            const w = sideH * ratioOf(items[idx]);
            dist += (k === ad ? w / 2 : w + gap);
          }
          x = Math.sign(d) * dist;
        }
        const visible = Math.abs(x) < W / 2 + sideH;
        el.style.setProperty('--x', `${x.toFixed(1)}px`);
        el.style.setProperty('--h', `${h.toFixed(1)}px`);
        el.style.setProperty('--o', visible ? '1' : '0');
        el.style.setProperty('--z', String(100 - ad));
        el.style.top = `${centerY.toFixed(1)}px`;
        el.classList.toggle('is-active', ad === 0);
        el.setAttribute('aria-hidden', visible ? 'false' : 'true');
        el.tabIndex = visible ? 0 : -1;
      });
      if (nav) nav.style.top = `${(centerY + activeH / 2 + 10).toFixed(1)}px`;
    }

    function renderInfo() {
      const p = products[index];
      if (!p) return;
      if (info.title) info.title.textContent = p.title;
      if (info.desc) info.desc.textContent = p.desc || '';
      if (info.link) info.link.href = p.url;
      if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(products.length).padStart(2, '0')}`;
      if (!buy.form) return;

      const variants = p.variants || [];
      const showSizes = variants.length > 1 || (variants[0] && variants[0].title !== 'Default Title');
      buy.sizes.innerHTML = '';
      if (showSizes) {
        variants.forEach((v) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = `size${v.available ? '' : ' is-out'}`;
          b.setAttribute('role', 'radio');
          b.dataset.variant = v.id;
          b.textContent = v.title;
          if (!v.available) b.setAttribute('aria-disabled', 'true');
          buy.sizes.appendChild(b);
        });
      }
      selectVariant(variants.find((v) => v.available) || variants[0]);
      if (buy.wish) buy.wish.dataset.wishToggle = p.handle;
      syncWishUI();
    }

    function selectVariant(v) {
      if (!buy.form) return;
      if (!v) { buy.submit.disabled = true; return; }
      buy.variant.value = v.id;
      buy.price.innerHTML = v.compare ? `${v.price} <s>${v.compare}</s>` : v.price;
      buy.submit.disabled = !v.available;
      buy.submit.textContent = v.available ? S.strings.addToCart : S.strings.soldOut;
      $$('.size', buy.sizes).forEach((b) => b.setAttribute('aria-checked', String(b.dataset.variant) === String(v.id) ? 'true' : 'false'));
    }

    function go(i) {
      const n = items.length;
      index = ((i % n) + n) % n;
      layout();
      renderInfo();
    }

    if (buy.form) {
      buy.sizes.addEventListener('click', (e) => {
        const b = e.target.closest('.size');
        if (!b) return;
        selectVariant(products[index].variants.find((x) => String(x.id) === b.dataset.variant));
      });
      buy.form.addEventListener('submit', (e) => {
        e.preventDefault();
        addToCart(buy.variant.value, buy.submit);
      });
    }

    items.forEach((el) => {
      el.addEventListener('click', (e) => {
        const i = Number(el.dataset.index);
        if (i !== index) { e.preventDefault(); go(i); stopAuto(); }
        // the centered product is a normal link to the product page
      });
      el.addEventListener('dragstart', (e) => e.preventDefault());
      const img = $('img', el);
      if (img && !img.complete) img.addEventListener('load', layout, { once: true });
    });
    $('[data-prev]', stage).addEventListener('click', () => { go(index - 1); stopAuto(); });
    $('[data-next]', stage).addEventListener('click', () => { go(index + 1); stopAuto(); });

    stage.addEventListener('keydown', (e) => {
      if (e.target.closest('input, textarea')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); stopAuto(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); stopAuto(); }
    });

    // Horizontal trackpad scroll
    let wheelLock = false;
    stage.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY) || Math.abs(e.deltaX) < 12) return;
      e.preventDefault();
      if (wheelLock) return;
      wheelLock = true;
      go(index + (e.deltaX > 0 ? 1 : -1));
      stopAuto();
      setTimeout(() => { wheelLock = false; }, 550);
    }, { passive: false });

    // Drag with mouse or finger — products follow the hand, then snap
    let startX = null;
    let startY = null;
    let dx = 0;
    let dragging = false;
    let suppressClick = false;
    const track = $('[data-track]', stage);
    const setDrag = (px) => track.style.setProperty('--dx', `${px}px`);

    stage.addEventListener('pointerdown', (e) => {
      if (e.button !== 0 || e.target.closest('.buy, .stage__info, .stage__nav')) return;
      startX = e.clientX; startY = e.clientY; dx = 0; dragging = false;
    });
    stage.addEventListener('pointermove', (e) => {
      if (startX === null) return;
      const mx = e.clientX - startX;
      const my = e.clientY - startY;
      if (!dragging) {
        if (Math.abs(mx) < 6) return;
        if (Math.abs(my) > Math.abs(mx)) { startX = null; return; } // vertical scroll on touch
        dragging = true;
        stage.classList.add('is-dragging');
        try { stage.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        stopAuto();
      }
      dx = mx;
      setDrag(dx);
    });
    const endDrag = () => {
      if (startX === null) return;
      startX = null;
      if (!dragging) return;
      dragging = false;
      suppressClick = true;
      setTimeout(() => { suppressClick = false; }, 50);
      let steps = Math.round(-dx / stepPx);
      if (steps === 0 && Math.abs(dx) > 30) steps = dx < 0 ? 1 : -1;
      steps = Math.max(-items.length + 1, Math.min(items.length - 1, steps));
      stage.classList.remove('is-dragging');
      requestAnimationFrame(() => {
        setDrag(0);
        go(index + steps);
      });
    };
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
    stage.addEventListener('click', (e) => {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    // Autoplay (pauses on hover and after any interaction)
    let timer = null;
    let hovering = false;
    function startAuto() {
      if (!autoplay || timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(() => { if (!hovering && root.dataset.view === 'showcase') go(index + 1); }, autoplay * 1000);
    }
    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
    stage.addEventListener('mouseenter', () => { hovering = true; });
    stage.addEventListener('mouseleave', () => { hovering = false; });
    startAuto();

    let rt;
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(layout, 80); });
    if ('ResizeObserver' in window) new ResizeObserver(() => layout()).observe(stage);

    api = { layout };
    go(0);
  }

  /* ---------- Product page ---------- */
  function initPDP(root) {
    const slides = $$('[data-pdp-slide]', root);
    const thumbs = $$('[data-pdp-thumb]', root);
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = t.dataset.pdpThumb;
      slides.forEach((s) => s.classList.toggle('is-active', s.dataset.pdpSlide === i));
      thumbs.forEach((x) => x.setAttribute('aria-current', x === t ? 'true' : 'false'));
    }));

    const form = $('[data-product-form]', root);
    if (!form) return;
    const input = $('[data-buy-variant]', form);
    const price = $('[data-buy-price]', form);
    const submit = $('[data-buy-submit]', form);
    $$('.size', form).forEach((b) => b.addEventListener('click', () => {
      $$('.size', form).forEach((x) => x.setAttribute('aria-checked', x === b ? 'true' : 'false'));
      input.value = b.dataset.variant;
      price.innerHTML = b.dataset.price;
      const ok = b.dataset.available === 'true';
      const low = $('[data-low-stock]', root);
      if (low) {
        const n = Number(b.dataset.stock);
        const show = b.dataset.stock !== '' && n > 0 && n <= Number(low.dataset.threshold);
        low.hidden = !show;
        if (show) low.textContent = low.dataset.template.replace('[n]', n);
      }
      const sb = $('[data-sticky-btn]', root);
      if (sb) { sb.disabled = !ok; sb.textContent = ok ? S.strings.addToCart : S.strings.soldOut; }
      submit.disabled = !ok;
      submit.textContent = ok ? S.strings.addToCart : S.strings.soldOut;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', b.dataset.variant);
      window.history.replaceState({}, '', url);
    }));
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      addToCart(input.value, submit);
    });

    const viewers = $('[data-viewers]', root);
    if (viewers) {
      const min = Number(viewers.dataset.min) || 5;
      const max = Math.max(min + 1, Number(viewers.dataset.max) || 20);
      let n = min + Math.floor(Math.random() * (max - min + 1));
      const draw = () => { viewers.textContent = viewers.dataset.template.replace('[n]', n); viewers.hidden = false; };
      draw();
      setInterval(() => { n = Math.min(max, Math.max(min, n + (Math.random() > 0.5 ? 1 : -1))); draw(); }, 7000);
    }

    const sticky = $('[data-sticky-atc]', root);
    if (sticky && 'IntersectionObserver' in window) {
      const sb = $('[data-sticky-btn]', sticky);
      sb.addEventListener('click', () => addToCart(input.value, sb));
      new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting || window.innerWidth >= 990;
      }).observe(form);
    }
  }

  async function initRelated(el) {
    if (!el || el.dataset.loaded) return;
    el.dataset.loaded = '1';
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-related]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        $$('[data-showcase]', el).forEach(initShowcase);
        syncWishUI();
      }
    } catch (e) { /* recommendations unavailable */ }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initPopup();
    $$('[data-related]').forEach(initRelated);
    initHeader();
    $$('[data-showcase]').forEach(initShowcase);
    $$('[data-pdp]').forEach(initPDP);
    syncWishUI();
  });

  // Theme editor: re-init a section after it is edited
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-showcase]', e.target).forEach(initShowcase);
    $$('[data-pdp]', e.target).forEach(initPDP);
    if ($('[data-header]', e.target)) initHeader();
    syncWishUI();
  });
})();
